package com.milta.core.localization.translations.ro

import com.milta.core.localization.HomeStrings

internal val Home = HomeStrings(
    navTournee = "Tur",
    navEcoDriving = "Eco condus",
    navCommunity = "Comunitate",
    navRewards = "Recompense",
    navHome = "Acasă",
    navRoutes = "Trasee",
    navTeam = "Echipă",
    navProfile = "Profil",
)
